import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Grid } from "@material-ui/core";

import { StandAloneNotes } from "../../modules/StandAloneNotes/StandAloneNotes";

const NotesComponent = ({ notes, loanId, postNote, putNote, deleteNote, authentication }) => (
  <Grid container>
    <StandAloneNotes
      notes={notes}
      authentication={authentication}
      onAdd={note => postNote({ note, loanId })}
      onUpdate={note => putNote({ note, loanId })}
      onRemove={note => deleteNote({ noteId: note.id, loanId })}
      type="loan"
    />
  </Grid>
);

export default (NotesComponent);

